import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React from 'react';

class Graph extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            timestamp: null
        }
    }

    render() {
        if (!this.props.graph.report) return null;

        const data = this.props.graph.report.reduce((array, row) => {
            const object = {};

            this.props.graph.params.map((param, index) => object[param] = row[index]);

            return [ ...array, object ];
        }, [])

        return (
            <ResponsiveContainer width={'100%'} height={300}>
                <LineChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right"/>
                    <Tooltip/>
                    <Legend/>

                    <Line yAxisId="left" type="linear" dataKey="clicks" stroke="#ff0000" dot={{ stroke: '#ff0000', strokeWidth: 3 }} activeDot={{ stroke: '#ff0000', strokeWidth: 3 }} strokeWidth={3}/>
                    <Line yAxisId="left" type="linear" dataKey="spent" stroke="#008000" dot={{ stroke: '#008000', strokeWidth: 3 }} activeDot={{ stroke: '#008000', strokeWidth: 3 }} strokeWidth={3} />
                    <Line yAxisId="left" type="linear" dataKey="revenue" stroke="#F19A3E" dot={{ stroke: '#F19A3E', strokeWidth: 3 }} activeDot={{ stroke: '#F19A3E', strokeWidth: 3 }} strokeWidth={3} />
                    <Line yAxisId="right" type="linear" dataKey="roi" stroke="#F08700" dot={{ stroke: '#F08700', strokeWidth: 3 }} activeDot={{ stroke: '#F08700', strokeWidth: 3 }} strokeWidth={3} />
                </LineChart>
            </ResponsiveContainer>
        )
    }
}

export default Graph;


// WEBPACK FOOTER //
// ./src/scenes/AdContentArbitrage/components/Graph/index.js